import Card from '@mui/joy/Card';
import Link from '@mui/joy/Link';
import Typography from '@mui/joy/Typography';
import AspectRatio from '@mui/joy/AspectRatio';

import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';

export default function DropZone({ icon, sx, onFileSelect, title = "", fileExists, ...other }) {
  return (
    <Card
      onDragOver={(e) => { e.preventDefault(); }}
      onDrop={(e) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
          console.log('File dropped:', e.dataTransfer.files[0]);
          // Call the same onFileSelect prop here
          onFileSelect(e.dataTransfer.files[0]);
        }
      }}
      variant="soft"
      {...other}
      sx={[
        {
          borderRadius: 'sm',
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          alignItems: 'center',
          px: 3,
          flexGrow: 1,
          boxShadow: 'none',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <AspectRatio
        ratio="1"
        variant="solid"
        color="primary"
        sx={{ minWidth: 32, borderRadius: '50%', '--Icon-fontSize': '16px' }}
      >
        <div>{icon ?? <FileUploadRoundedIcon />}</div>
      </AspectRatio>
      <input
        type="file"
        id="file-upload"
        style={{ display: 'none' }}
        accept=".pdf, .docx"
        onChange={(e) => {
          if (e.target.files && e.target.files[0]) {
            // Handle file upload - you can add state to show selected file
            console.log('File selected:', e.target.files[0]);
            // Call a prop like onFileSelect(e.target.files[0]) here if needed
            onFileSelect(e.target.files[0]);
            e.target.value = null; // Clear the input value after selection
          }
        }}
      />
      <Typography level="body-sm" sx={{ textAlign: 'center' }}>
        <Link
          component="label"
          htmlFor="file-upload"
          overlay
        >
          Click to {fileExists ? "update" : "upload"}
        </Link>{' '}
        or drag and drop
        <br /> PDF or DOCX file {title}
      </Typography>
      {/* Add these props to the Card component above:

      */}
    </Card>
  );
}
